import React, { useState } from "react";
import { CalendarDays, ChevronLeft, ChevronRight } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../components/reusableComponents/Popover";
export default function TaskCalendar({ date, onChange, today }) {
  const [open, setOpen] = useState(false);
  const [month, setMonth] = useState(date.slice(0, 7));
  const first = new Date(`${month}-01T12:00:00`);
  const offset = (first.getDay() + 6) % 7;
  const days = new Date(first.getFullYear(), first.getMonth() + 1, 0).getDate();
  const shift = (direction) => {
    const next = new Date(
      first.getFullYear(),
      first.getMonth() + direction,
      1,
      12,
    );
    setMonth(
      `${next.getFullYear()}-${String(next.getMonth() + 1).padStart(2, "0")}`,
    );
  };
  const select = (value) => {
    onChange(value);
    setOpen(false);
  };
  return (
    <Popover
      open={open}
      onOpenChange={(value) => {
        setOpen(value);
        if (value) setMonth(date.slice(0, 7));
      }}
    >
      <PopoverTrigger asChild>
        <button type="button" className="secondary">
          <CalendarDays />
          Calendrier
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        className="bg-white text-slate-800 w-80 rounded-xl border-slate-200 p-4 shadow-lg"
      >
        <div className="flex items-center justify-between mb-3">
          <button
            type="button"
            aria-label="Mois précédent"
            onClick={() => shift(-1)}
            className="p-2 rounded-lg hover:bg-slate-100"
          >
            <ChevronLeft size={18} />
          </button>
          <strong className="capitalize text-sm">
            {first.toLocaleDateString("fr-FR", {
              month: "long",
              year: "numeric",
            })}
          </strong>
          <button
            type="button"
            aria-label="Mois suivant"
            onClick={() => shift(1)}
            className="p-2 rounded-lg hover:bg-slate-100"
          >
            <ChevronRight size={18} />
          </button>
        </div>
        <div
          className="grid grid-cols-7 gap-1 text-center text-sm"
          aria-label="Choisir le jour des tâches"
        >
          {["Lu", "Ma", "Me", "Je", "Ve", "Sa", "Di"].map((day) => (
            <span key={day} className="py-2 text-slate-500 text-xs">
              {day}
            </span>
          ))}
          {Array.from({ length: offset }, (_, index) => (
            <span key={`empty-${index}`} />
          ))}
          {Array.from({ length: days }, (_, index) => {
            const day = index + 1;
            const value = `${month}-${String(day).padStart(2, "0")}`;
            return (
              <button
                type="button"
                key={value}
                aria-label={new Date(`${value}T12:00:00`).toLocaleDateString(
                  "fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" },
                )}
                aria-pressed={value === date}
                onClick={() => select(value)}
                className={`h-9 rounded-lg ${value === date ? "bg-[#074b78] text-white" : value === today ? "bg-sky-50 font-semibold text-[#074b78]" : "hover:bg-slate-100"}`}
              >
                {day}
              </button>
            );
          })}
        </div>
        <button
          type="button"
          className="mt-3 w-full rounded-lg border border-slate-200 py-2 text-sm text-[#074b78] hover:bg-slate-50"
          onClick={() => select(today)}
        >
          Aujourd’hui
        </button>
      </PopoverContent>
    </Popover>
  );
}
